import { render, staticRenderFns } from "./PriceListPage.vue?vue&type=template&id=369f55af&scoped=true&"
import script from "./PriceListPage.vue?vue&type=script&lang=js&"
export * from "./PriceListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369f55af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('369f55af')) {
      api.createRecord('369f55af', component.options)
    } else {
      api.reload('369f55af', component.options)
    }
    module.hot.accept("./PriceListPage.vue?vue&type=template&id=369f55af&scoped=true&", function () {
      api.rerender('369f55af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/PriceListPage.vue"
export default component.exports